import { useState } from 'react'
import { supabase } from '../../utils/supabaseClient'
import { useNavigate } from 'react-router-dom'
import styles from './PasswordRecovery.module.scss'

export default function PasswordRecovery() {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [message, setMessage] = useState(null)
  const navigate = useNavigate()

  const handlePasswordReset = async (event) => {
    event.preventDefault()
    setError(null)
    setMessage(null)
    setLoading(true)

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `https://app.somospapo.com/recovery-update-password`,
      })

      if (error) {
        setError(error.message)
      } else {
        setMessage('Check your email for the password reset link!')
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.')
      console.error('Password reset error:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={`row ${styles.flexCenter}`}>
      <div className={`${styles.col6} ${styles.formWidget}`}>
        <h1 className={styles.header}>Recuperar Contraseña</h1>
        <article className={styles.description}>
          <p>Ingresa tu correo electrónico y te enviaremos un link para restablecer tu contraseña</p>
        </article>
        {error && <div className={styles.error}>{error}</div>}
        {message && <div className={styles.success}>{message}</div>}
        <form className={styles.formWidget} onSubmit={handlePasswordReset}>
          <div>
            <input
              className={styles.inputField}
              type="email"
              placeholder="Email"
              value={email}
              required={true}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <button className={styles.button} disabled={loading}>
              {loading ? <span>Loading</span> : <span>Enviar link</span>}
            </button>
          </div>
        </form>
        <button 
          className={styles.switchButton} 
          onClick={() => navigate('/login')}
        >
          Volver al login
        </button>
      </div>
    </div>
  )
} 